import React, { useContext } from 'react';

import { Button } from '$partials/ui';
import { CarouselContext } from '$partials/base/carousel.jsx';
import { Dispatcher as IconDispatcher } from '$partials/icon';

import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselControls = () => {
    // hooks
    const {
        isNextDisabled,
        isPrevDisabled,
        swiper,
    } = useContext(CarouselContext);

    const { translate: t } = useLanguage();

    // render
    return (
        <div className='flex flex-wrap justify-end'>
            <Button
                action={() => swiper?.slidePrev()}
                aria-label={t('Previous slide')}
                className='mr6'
                disabled={isPrevDisabled}
                type='button'>
                <IconDispatcher name='IconChevronLeft' />
            </Button>

            <Button
                action={() => swiper?.slideNext()}
                aria-label={t('Next slide')}
                disabled={isNextDisabled}
                type='button'>
                <IconDispatcher name='IconChevronRight' />
            </Button>
        </div>
    );
};


/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

CarouselControls.propTypes = {};

export { CarouselControls };

export default CarouselControls;
